// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  font-family: "Lato", sans-serif;
  font-weight: 300;
  text-align: center;
  font-size: 18px;
  color: #676767;
}
.frame {
  width: 90%;
  margin: 40px auto;
  text-align: center;
}
button {
  margin: 20px;
}
.custom-btn {
  width: 130px;
  height: 40px;
  color: #fff;
  border-radius: 5px;
  padding: 10px 25px;
  font-family: "Lato", sans-serif;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),
    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);
  outline: none;
}

/* 1 */
.btn-1 {
  background: rgb(6, 14, 131);
  background: linear-gradient(
    0deg,
    rgba(6, 14, 131, 1) 0%,
    rgba(12, 25, 180, 1) 100%
  );
  border: none;
}
.btn-1:hover {
  background: rgb(0, 3, 255);
  background: linear-gradient(
    0deg,
    rgba(0, 3, 255, 1) 0%,
    rgba(2, 126, 251, 1) 100%
  );
}

/* 2 */
.btn-2 {
  background: rgb(96, 9, 240);
  background: linear-gradient(
    0deg,
    rgba(96, 9, 240, 1) 0%,
    rgba(129, 5, 240, 1) 100%
  );
  border: none;
}
.btn-2:before {
  height: 0%;
  width: 2px;
}
.btn-2:hover {
  box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.5),
    -4px -4px 6px 0 rgba(116, 125, 136, 0.5),
    inset -4px -4px 6px 0 rgba(255, 255, 255, 0.2),
    inset 4px 4px 6px 0 rgba(0, 0, 0, 0.4);
}

/* 3 */
.btn-3 {
  background: rgb(0, 172, 238);
  background: linear-gradient(
    0deg,
    rgba(0, 172, 238, 1) 0%,
    rgba(2, 126, 251, 1) 100%
  );
  width: 130px;
  height: 40px;
  line-height: 42px;
  padding: 0;
  border: none;
}
.btn-3 span {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.btn-3:before,
.btn-3:after {
  position: absolute;
  content: "";
  right: 0;
  top: 0;
  background: rgba(2, 126, 251, 1);
  transition: all 0.3s ease;
}
.btn-3:before {
  height: 0%;
  width: 2px;
}
.btn-3:after {
  width: 0%;
  height: 2px;
}
.btn-3:hover {
  background: transparent;
  box-shadow: none;
}
.btn-3:hover:before {
  height: 100%;
}
.btn-3:hover:after {
  width: 100%;
}
.btn-3 span:hover {
  color: rgba(2, 126, 251, 1);
}
.btn-3 span:before,
.btn-3 span:after {
  position: absolute;
  content: "";
  left: 0;
  bottom: 0;
  background: rgba(2, 126, 251, 1);
  transition: all 0.3s ease;
}
.btn-3 span:before {
  width: 2px;
  height: 0%;
}
.btn-3 span:after {
  width: 0%;
  height: 2px;
}
.btn-3 span:hover:before {
  height: 100%;
}
.btn-3 span:hover:after {
  width: 100%;
}

/* 4 */
.btn-4 {
  background-color: #4dccc6;
  background-image: linear-gradient(315deg, #4dccc6 0%, #96e4df 74%);
  line-height: 42px;
  padding: 0;
  border: none;
}
.btn-4:hover {
  background-color: #89d8d3;
  background-image: linear-gradient(315deg, #89d8d3 0%, #03c8a8 74%);
}
.btn-4 span {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.btn-4:before,
.btn-4:after {
  position: absolute;
  content: "";
  right: 0;
  top: 0;
  box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.9),
    -4px -4px 6px 0 rgba(116, 125, 136, 0.2),
    inset -4px -4px 6px 0 rgba(255, 255, 255, 0.9),
    inset 4px 4px 6px 0 rgba(116, 125, 136, 0.3);
  transition: all 0.3s ease;
}
.btn-4:before {
  height: 0%;
  width: 0.1px;
}
.btn-4:after {
  width: 0%;
  height: 0.1px;
}
.btn-4:hover:before {
  height: 100%;
}
.btn-4:hover:after {
  width: 100%;
}
.btn-4 span:before,
.btn-4 span:after {
  position: absolute;
  content: "";
  left: 0;
  bottom: 0;
  box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.9),
    -4px -4px 6px 0 rgba(116, 125, 136, 0.2),
    inset -4px -4px 6px 0 rgba(255, 255, 255, 0.9),
    inset 4px 4px 6px 0 rgba(116, 125, 136, 0.3);
  transition: all 0.3s ease;
}
.btn-4 span:before {
  width: 0.1px;
  height: 0%;
}
.btn-4 span:after {
  width: 0%;
  height: 0.1px;
}
.btn-4 span:hover:before {
  height: 100%;
}
.btn-4 span:hover:after {
  width: 100%;
}

/* 5 */
.btn-5 {
  width: 130px;
  height: 40px;
  line-height: 42px;
  padding: 0;
  border: none;
  background: rgb(255, 27, 0);
  background: linear-gradient(
    0deg,
    rgba(255, 27, 0, 1) 0%,
    rgba(251, 75, 2, 1) 100%
  );
}
.btn-5:hover {
  color: #f0094a;
  background: transparent;
  box-shadow: none;
}
.btn-5:before,
.btn-5:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 2px;
  width: 0;
  background: #f0094a;
  box-shadow: -1px -1px 5px 0px #fff, 7px 7px 20px 0px #0003,
    4px 4px 5px 0px #0002;
  transition: 400ms ease all;
}
.btn-5:after {
  right: inherit;
  top: inherit;
  left: 0;
  bottom: 0;
}
.btn-5:hover:before,
.btn-5:hover:after {
  width: 100%;
  transition: 800ms ease all;
}

/* 6 */
.btn-6 {
  background: rgb(247, 150, 192);
  background: radial-gradient(
    circle,
    rgba(247, 150, 192, 1) 0%,
    rgba(118, 174, 241, 1) 100%
  );
  line-height: 42px;
  padding: 0;
  border: none;
}
.btn-6 span {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.btn-6:before,
.btn-6:after {
  position: absolute;
  content: "";
  height: 0%;
  width: 1px;
  box-shadow: -1px -1px 20px 0px rgba(255, 255, 255, 1),
    -4px -4px 5px 0px rgba(255, 255, 255, 1),
    7px 7px 20px 0px rgba(0, 0, 0, 0.4), 4px 4px 5px 0px rgba(0, 0, 0, 0.3);
}
.btn-6:before {
  right: 0;
  top: 0;
  transition: all 500ms ease;
}
.btn-6:after {
  left: 0;
  bottom: 0;
  transition: all 500ms ease;
}
.btn-6:hover {
  background: transparent;
  color: #76aef1;
  box-shadow: none;
}
.btn-6:hover:before {
  transition: all 500ms ease;
  height: 100%;
}
.btn-6:hover:after {
  transition: all 500ms ease;
  height: 100%;
}
.btn-6 span:before,
.btn-6 span:after {
  position: absolute;
  content: "";
  box-shadow: -1px -1px 20px 0px rgba(255, 255, 255, 1),
    -4px -4px 5px 0px rgba(255, 255, 255, 1),
    7px 7px 20px 0px rgba(0, 0, 0, 0.4), 4px 4px 5px 0px rgba(0, 0, 0, 0.3);
}
.btn-6 span:before {
  left: 0;
  top: 0;
  width: 0%;
  height: 0.5px;
  transition: all 500ms ease;
}
.btn-6 span:after {
  right: 0;
  bottom: 0;
  width: 0%;
  height: 0.5px;
  transition: all 500ms ease;
}
.btn-6 span:hover:before {
  width: 100%;
}
.btn-6 span:hover:after {
  width: 100%;
}

/* 7 */
.btn-7 {
  background: linear-gradient(
    0deg,
    rgba(255, 151, 0, 1) 0%,
    rgba(251, 75, 2, 1) 100%
  );
  line-height: 42px;
  padding: 0;
  border: none;
}
.btn-7 span {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.btn-7:before,
.btn-7:after {
  position: absolute;
  content: "";
  right: 0;
  bottom: 0;
  background: rgba(251, 75, 2, 1);
  box-shadow: -7px -7px 20px 0px rgba(255, 255, 255, 0.9),
    -4px -4px 5px 0px rgba(255, 255, 255, 0.9),
    7px 7px 20px 0px rgba(0, 0, 0, 0.2), 4px 4px 5px 0px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}
.btn-7:before {
  height: 0%;
  width: 2px;
}
.btn-7:after {
  width: 0%;
  height: 2px;
}
.btn-7:hover {
  color: rgba(251, 75, 2, 1);
  background: transparent;
}
.btn-7:hover:before {
  height: 100%;
}
.btn-7:hover:after {
  width: 100%;
}
.btn-7 span:before,
.btn-7 span:after {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  background: rgba(251, 75, 2, 1);
  box-shadow: -7px -7px 20px 0px rgba(255, 255, 255, 0.9),
    -4px -4px 5px 0px rgba(255, 255, 255, 0.9),
    7px 7px 20px 0px rgba(0, 0, 0, 0.2), 4px 4px 5px 0px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}
.btn-7 span:before {
  width: 2px;
  height: 0%;
}
.btn-7 span:after {
  height: 2px;
  width: 0%;
}
.btn-7 span:hover:before {
  height: 100%;
}
.btn-7 span:hover:after {
  width: 100%;
}

/* 8 */
.btn-8 {
  background-color: #f0ecfc;
  background-image: linear-gradient(315deg, #f0ecfc 0%, #c797eb 74%);
  line-height: 42px;
  padding: 0;
  border: none;
}
.btn-8 span {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.btn-8:before,
.btn-8:after {
  position: absolute;
  content: "";
  right: 0;
  bottom: 0;
  background: #c797eb;
  /*box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),
              -4px -4px 6px 0 rgba(116, 125, 136, .2), 
    inset -4px -4px 6px 0 rgba(255,255,255,.5),
    inset 4px 4px 6px 0 rgba(116, 125, 136, .3);*/
  transition: all 0.3s ease;
}
.btn-8:before {
  height: 0%;
  width: 2px;
}
.btn-8:after {
  width: 0%;
  height: 2px;
}
.btn-8:hover:before {
  height: 100%;
}
.btn-8:hover:after {
  width: 100%;
}
.btn-8:hover {
  background: transparent;
}
.btn-8 span:hover {
  color: #c797eb;
}
.btn-8 span:before,
.btn-8 span:after {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  background: #c797eb;
  /*box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),
              -4px -4px 6px 0 rgba(116, 125, 136, .2), 
    inset -4px -4px 6px 0 rgba(255,255,255,.5),
    inset 4px 4px 6px 0 rgba(116, 125, 136, .3);*/
  transition: all 0.3s ease;
}
.btn-8 span:before {
  width: 2px;
  height: 0%;
}
.btn-8 span:after {
  height: 2px;
  width: 0%;
}
.btn-8 span:hover:before {
  height: 100%;
}
.btn-8 span:hover:after {
  width: 100%;
}

/* 9 */
.btn-9 {
  border: none;
  transition: all 0.3s ease;
  overflow: hidden;
}
.btn-9:after {
  position: absolute;
  content: " ";
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1fd1f9;
  background-image: linear-gradient(315deg, #1fd1f9 0%, #b621fe 74%);
  transition: all 0.3s ease;
}
.btn-9:hover {
  background: transparent;
  box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.5),
    -4px -4px 6px 0 rgba(116, 125, 136, 0.2),
    inset -4px -4px 6px 0 rgba(255, 255, 255, 0.5),
    inset 4px 4px 6px 0 rgba(116, 125, 136, 0.3);
  color: #fff;
}
.btn-9:hover:after {
  transform: scale(2) rotate(180deg);
  box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.5),
    -4px -4px 6px 0 rgba(116, 125, 136, 0.2),
    inset -4px -4px 6px 0 rgba(255, 255, 255, 0.5),
    inset 4px 4px 6px 0 rgba(116, 125, 136, 0.3);
}

/* 10 */
.btn-10 {
  background: rgb(22, 9, 240);
  background: linear-gradient(
    0deg,
    rgba(22, 9, 240, 1) 0%,
    rgba(49, 110, 244, 1) 100%
  );
  color: #fff;
  border: none;
  transition: all 0.3s ease;
  overflow: hidden;
}
.btn-10:after {
  position: absolute;
  content: " ";
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  transition: all 0.3s ease;
  transform: scale(0.1);
}
.btn-10:hover {
  color: #fff;
  border: none;
  background: transparent;
}
.btn-10:hover:after {
  background: rgb(0, 3, 255);
  background: linear-gradient(
    0deg,
    rgba(2, 126, 251, 1) 0%,
    rgba(0, 3, 255, 1) 100%
  );
  transform: scale(1);
}

/* 11 */
.btn-11 {
  border: none;
  background: rgb(251, 33, 117);
  background: linear-gradient(
    0deg,
    rgba(251, 33, 117, 1) 0%,
    rgba(234, 76, 137, 1) 100%
  );
  color: #fff;
  overflow: hidden;
}
.btn-11:hover {
  text-decoration: none;
  color: #fff;
}
.btn-11:before {
  position: absolute;
  content: "";
  display: inline-block;
  top: -180px;
  left: 0;
  width: 30px;
  height: 100%;
  background-color: #fff;
  animation: shiny-btn1 3s ease-in-out infinite;
}
.btn-11:hover {
  opacity: 0.7;
}
.btn-11:active {
  box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.3),
    -4px -4px 6px 0 rgba(116, 125, 136, 0.2),
    inset -4px -4px 6px 0 rgba(255, 255, 255, 0.2),
    inset 4px 4px 6px 0 rgba(0, 0, 0, 0.2);
}

/* 12 */
.btn-12 {
  position: relative;
  right: 20px;
  bottom: 20px;
  border: none;
  box-shadow: none;
  width: 130px;
  height: 40px;
  line-height: 42px;
  perspective: 230px;
}
.btn-12 span {
  background: rgb(0, 172, 238);
  background: linear-gradient(
    0deg,
    rgba(0, 172, 238, 1) 0%,
    rgba(2, 126, 251, 1) 100%
  );
  display: block;
  position: absolute;
  width: 130px;
  height: 40px;
  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),
    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin: 0;
  text-align: center;
  box-sizing: border-box;
  transition: all 0.3s;
}
.btn-12 span:nth-child(1) {
  box-shadow: -7px -7px 20px 0px #fff9, -4px -4px 5px 0px #fff9,
    7px 7px 20px 0px #0002, 4px 4px 5px 0px #0001;
  transform: rotateX(90deg);
  transform-origin: 50% 50% -20px;
}
.btn-12 span:nth-child(2) {
  transform: rotateX(0deg);
  transform-origin: 50% 50% -20px;
}
.btn-12:hover span:nth-child(1) {
  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),
    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);
  transform: rotateX(0deg);
}
.btn-12:hover span:nth-child(2) {
  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),
    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);
  color: transparent;
  transform: rotateX(-90deg);
}

/* 13 */
.btn-13 {
  background-color: #89d8d3;
  background-image: linear-gradient(315deg, #89d8d3 0%, #03c8a8 74%);
  border: none;
  z-index: 1;
}
.btn-13:after {
  position: absolute;
  content: "";
  width: 100%;
  height: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  border-radius: 5px;
  background-color: #4dccc6;
  background-image: linear-gradient(315deg, #4dccc6 0%, #96e4df 74%);
  box-shadow: -7px -7px 20px 0px #fff9, -4px -4px 5px 0px #fff9,
    7px 7px 20px 0px #0002, 4px 4px 5px 0px #0001;
  transition: all 0.3s ease;
}
.btn-13:hover {
  color: #fff;
}
.btn-13:hover:after {
  top: 0;
  height: 100%;
}
.btn-13:active {
  top: 2px;
}

/* 14 */
.btn-14 {
  background: rgb(255, 151, 0);
  border: none;
  z-index: 1;
}

.btn-14:hover {
  color: #000;
}
.btn-14:hover:after {
  top: auto;
  bottom: 0;
  height: 100%;
}
.btn-14:active {
  top: 2px;
}

/* 15 */
.btn-15 {
  background: #b621fe;
  border: none;
  z-index: 1;
}
.btn-15:after {
  position: absolute;
  content: "";
  width: 0;
  height: 100%;
  top: 0;
  right: 0;
  z-index: -1;
  background-color: #663dff;
  border-radius: 5px;
  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),
    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.btn-15:hover {
  color: #fff;
}
.btn-15:hover:after {
  left: 0;
  width: 100%;
}
.btn-15:active {
  top: 2px;
}

/* 16 */
.btn-16 {
  border: none;
  color: #000;
}
.btn-16:after {
  position: absolute;
  content: "";
  width: 0;
  height: 100%;
  top: 0;
  left: 0;
  direction: rtl;
  z-index: -1;
  box-shadow: -7px -7px 20px 0px #fff9, -4px -4px 5px 0px #fff9,
    7px 7px 20px 0px #0002, 4px 4px 5px 0px #0001;
  transition: all 0.3s ease;
}
.btn-16:hover {
  color: #000;
}
.btn-16:hover:after {
  left: auto;
  right: 0;
  width: 100%;
}
.btn-16:active {
  top: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/settings/Company/CompanyDetails/Button4.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB;2EACyE;EACzE,aAAa;AACf;;AAEA,MAAM;AACN;EACE,2BAA2B;EAC3B;;;;GAIC;EACD,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B;;;;GAIC;AACH;;AAEA,MAAM;AACN;EACE,2BAA2B;EAC3B;;;;GAIC;EACD,YAAY;AACd;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE;;;0CAGwC;AAC1C;;AAEA,MAAM;AACN;EACE,4BAA4B;EAC5B;;;;GAIC;EACD,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,MAAM;EACN,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,SAAS;EACT,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;;AAEA,MAAM;AACN;EACE,yBAAyB;EACzB,kEAAkE;EAClE,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kEAAkE;AACpE;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,MAAM;EACN;;;gDAG8C;EAC9C,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,SAAS;EACT,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,SAAS;EACT;;;gDAG8C;EAC9C,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,SAAS;EACT,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;;AAEA,MAAM;AACN;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B;;;;GAIC;AACH;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,QAAQ;EACR,mBAAmB;EACnB;yBACuB;EACvB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,YAAY;EACZ,OAAO;EACP,SAAS;AACX;AACA;;EAEE,WAAW;EACX,0BAA0B;AAC5B;;AAEA,MAAM;AACN;EACE,8BAA8B;EAC9B;;;;GAIC;EACD,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;EACV;;2EAEyE;AAC3E;AACA;EACE,QAAQ;EACR,MAAM;EACN,0BAA0B;AAC5B;AACA;EACE,OAAO;EACP,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX;;2EAEyE;AAC3E;AACA;EACE,OAAO;EACP,MAAM;EACN,SAAS;EACT,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,QAAQ;EACR,SAAS;EACT,SAAS;EACT,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA,MAAM;AACN;EACE;;;;GAIC;EACD,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B;;2EAEyE;EACzE,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,MAAM;EACN,+BAA+B;EAC/B;;2EAEyE;EACzE,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;;AAEA,MAAM;AACN;EACE,yBAAyB;EACzB,kEAAkE;EAClE,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB;;;iDAG+C;EAC/C,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,MAAM;EACN,mBAAmB;EACnB;;;iDAG+C;EAC/C,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;;AAEA,MAAM;AACN;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kEAAkE;EAClE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB;;;gDAG8C;EAC9C,WAAW;AACb;AACA;EAEE,kCAAkC;EAClC;;;gDAG8C;AAChD;;AAEA,OAAO;AACP;EACE,2BAA2B;EAC3B;;;;GAIC;EACD,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EAEzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B;;;;GAIC;EAED,mBAAmB;AACrB;;AAEA,OAAO;AACP;EACE,YAAY;EACZ,6BAA6B;EAC7B;;;;GAIC;EACD,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6CAA6C;AAC/C;AACA;EACE,YAAY;AACd;AACA;EACE;;;0CAGwC;AAC1C;;AAqBA,OAAO;AACP;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EAEjB,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B;;;;GAIC;EACD,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ;2EACyE;EACzE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAGlB,sBAAsB;EAEtB,oBAAoB;AACtB;AACA;EACE;iDAC+C;EAG/C,yBAAyB;EAGzB,+BAA+B;AACjC;AACA;EAGE,wBAAwB;EAGxB,+BAA+B;AACjC;AACA;EACE;2EACyE;EAGzE,wBAAwB;AAC1B;AACA;EACE;2EACyE;EACzE,kBAAkB;EAGlB,0BAA0B;AAC5B;;AAEA,OAAO;AACP;EACE,yBAAyB;EACzB,kEAAkE;EAClE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,SAAS;EACT,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kEAAkE;EAClE;iDAC+C;EAC/C,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,MAAM;EACN,YAAY;AACd;AACA;EACE,QAAQ;AACV;;AAEA,OAAO;AACP;EACE,4BAA4B;EAC5B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;AACA;EACE,SAAS;EACT,SAAS;EACT,YAAY;AACd;AACA;EACE,QAAQ;AACV;;AAEA,OAAO;AACP;EACE,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,MAAM;EACN,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB;2EACyE;EACzE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,OAAO;EACP,WAAW;AACb;AACA;EACE,QAAQ;AACV;;AAEA,OAAO;AACP;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX;iDAC+C;EAC/C,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,QAAQ;EACR,WAAW;AACb;AACA;EACE,QAAQ;AACV","sourcesContent":["p {\n  font-family: \"Lato\", sans-serif;\n  font-weight: 300;\n  text-align: center;\n  font-size: 18px;\n  color: #676767;\n}\n.frame {\n  width: 90%;\n  margin: 40px auto;\n  text-align: center;\n}\nbutton {\n  margin: 20px;\n}\n.custom-btn {\n  width: 130px;\n  height: 40px;\n  color: #fff;\n  border-radius: 5px;\n  padding: 10px 25px;\n  font-family: \"Lato\", sans-serif;\n  font-weight: 500;\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  display: inline-block;\n  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),\n    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);\n  outline: none;\n}\n\n/* 1 */\n.btn-1 {\n  background: rgb(6, 14, 131);\n  background: linear-gradient(\n    0deg,\n    rgba(6, 14, 131, 1) 0%,\n    rgba(12, 25, 180, 1) 100%\n  );\n  border: none;\n}\n.btn-1:hover {\n  background: rgb(0, 3, 255);\n  background: linear-gradient(\n    0deg,\n    rgba(0, 3, 255, 1) 0%,\n    rgba(2, 126, 251, 1) 100%\n  );\n}\n\n/* 2 */\n.btn-2 {\n  background: rgb(96, 9, 240);\n  background: linear-gradient(\n    0deg,\n    rgba(96, 9, 240, 1) 0%,\n    rgba(129, 5, 240, 1) 100%\n  );\n  border: none;\n}\n.btn-2:before {\n  height: 0%;\n  width: 2px;\n}\n.btn-2:hover {\n  box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.5),\n    -4px -4px 6px 0 rgba(116, 125, 136, 0.5),\n    inset -4px -4px 6px 0 rgba(255, 255, 255, 0.2),\n    inset 4px 4px 6px 0 rgba(0, 0, 0, 0.4);\n}\n\n/* 3 */\n.btn-3 {\n  background: rgb(0, 172, 238);\n  background: linear-gradient(\n    0deg,\n    rgba(0, 172, 238, 1) 0%,\n    rgba(2, 126, 251, 1) 100%\n  );\n  width: 130px;\n  height: 40px;\n  line-height: 42px;\n  padding: 0;\n  border: none;\n}\n.btn-3 span {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.btn-3:before,\n.btn-3:after {\n  position: absolute;\n  content: \"\";\n  right: 0;\n  top: 0;\n  background: rgba(2, 126, 251, 1);\n  transition: all 0.3s ease;\n}\n.btn-3:before {\n  height: 0%;\n  width: 2px;\n}\n.btn-3:after {\n  width: 0%;\n  height: 2px;\n}\n.btn-3:hover {\n  background: transparent;\n  box-shadow: none;\n}\n.btn-3:hover:before {\n  height: 100%;\n}\n.btn-3:hover:after {\n  width: 100%;\n}\n.btn-3 span:hover {\n  color: rgba(2, 126, 251, 1);\n}\n.btn-3 span:before,\n.btn-3 span:after {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  bottom: 0;\n  background: rgba(2, 126, 251, 1);\n  transition: all 0.3s ease;\n}\n.btn-3 span:before {\n  width: 2px;\n  height: 0%;\n}\n.btn-3 span:after {\n  width: 0%;\n  height: 2px;\n}\n.btn-3 span:hover:before {\n  height: 100%;\n}\n.btn-3 span:hover:after {\n  width: 100%;\n}\n\n/* 4 */\n.btn-4 {\n  background-color: #4dccc6;\n  background-image: linear-gradient(315deg, #4dccc6 0%, #96e4df 74%);\n  line-height: 42px;\n  padding: 0;\n  border: none;\n}\n.btn-4:hover {\n  background-color: #89d8d3;\n  background-image: linear-gradient(315deg, #89d8d3 0%, #03c8a8 74%);\n}\n.btn-4 span {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.btn-4:before,\n.btn-4:after {\n  position: absolute;\n  content: \"\";\n  right: 0;\n  top: 0;\n  box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.9),\n    -4px -4px 6px 0 rgba(116, 125, 136, 0.2),\n    inset -4px -4px 6px 0 rgba(255, 255, 255, 0.9),\n    inset 4px 4px 6px 0 rgba(116, 125, 136, 0.3);\n  transition: all 0.3s ease;\n}\n.btn-4:before {\n  height: 0%;\n  width: 0.1px;\n}\n.btn-4:after {\n  width: 0%;\n  height: 0.1px;\n}\n.btn-4:hover:before {\n  height: 100%;\n}\n.btn-4:hover:after {\n  width: 100%;\n}\n.btn-4 span:before,\n.btn-4 span:after {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  bottom: 0;\n  box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.9),\n    -4px -4px 6px 0 rgba(116, 125, 136, 0.2),\n    inset -4px -4px 6px 0 rgba(255, 255, 255, 0.9),\n    inset 4px 4px 6px 0 rgba(116, 125, 136, 0.3);\n  transition: all 0.3s ease;\n}\n.btn-4 span:before {\n  width: 0.1px;\n  height: 0%;\n}\n.btn-4 span:after {\n  width: 0%;\n  height: 0.1px;\n}\n.btn-4 span:hover:before {\n  height: 100%;\n}\n.btn-4 span:hover:after {\n  width: 100%;\n}\n\n/* 5 */\n.btn-5 {\n  width: 130px;\n  height: 40px;\n  line-height: 42px;\n  padding: 0;\n  border: none;\n  background: rgb(255, 27, 0);\n  background: linear-gradient(\n    0deg,\n    rgba(255, 27, 0, 1) 0%,\n    rgba(251, 75, 2, 1) 100%\n  );\n}\n.btn-5:hover {\n  color: #f0094a;\n  background: transparent;\n  box-shadow: none;\n}\n.btn-5:before,\n.btn-5:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 2px;\n  width: 0;\n  background: #f0094a;\n  box-shadow: -1px -1px 5px 0px #fff, 7px 7px 20px 0px #0003,\n    4px 4px 5px 0px #0002;\n  transition: 400ms ease all;\n}\n.btn-5:after {\n  right: inherit;\n  top: inherit;\n  left: 0;\n  bottom: 0;\n}\n.btn-5:hover:before,\n.btn-5:hover:after {\n  width: 100%;\n  transition: 800ms ease all;\n}\n\n/* 6 */\n.btn-6 {\n  background: rgb(247, 150, 192);\n  background: radial-gradient(\n    circle,\n    rgba(247, 150, 192, 1) 0%,\n    rgba(118, 174, 241, 1) 100%\n  );\n  line-height: 42px;\n  padding: 0;\n  border: none;\n}\n.btn-6 span {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.btn-6:before,\n.btn-6:after {\n  position: absolute;\n  content: \"\";\n  height: 0%;\n  width: 1px;\n  box-shadow: -1px -1px 20px 0px rgba(255, 255, 255, 1),\n    -4px -4px 5px 0px rgba(255, 255, 255, 1),\n    7px 7px 20px 0px rgba(0, 0, 0, 0.4), 4px 4px 5px 0px rgba(0, 0, 0, 0.3);\n}\n.btn-6:before {\n  right: 0;\n  top: 0;\n  transition: all 500ms ease;\n}\n.btn-6:after {\n  left: 0;\n  bottom: 0;\n  transition: all 500ms ease;\n}\n.btn-6:hover {\n  background: transparent;\n  color: #76aef1;\n  box-shadow: none;\n}\n.btn-6:hover:before {\n  transition: all 500ms ease;\n  height: 100%;\n}\n.btn-6:hover:after {\n  transition: all 500ms ease;\n  height: 100%;\n}\n.btn-6 span:before,\n.btn-6 span:after {\n  position: absolute;\n  content: \"\";\n  box-shadow: -1px -1px 20px 0px rgba(255, 255, 255, 1),\n    -4px -4px 5px 0px rgba(255, 255, 255, 1),\n    7px 7px 20px 0px rgba(0, 0, 0, 0.4), 4px 4px 5px 0px rgba(0, 0, 0, 0.3);\n}\n.btn-6 span:before {\n  left: 0;\n  top: 0;\n  width: 0%;\n  height: 0.5px;\n  transition: all 500ms ease;\n}\n.btn-6 span:after {\n  right: 0;\n  bottom: 0;\n  width: 0%;\n  height: 0.5px;\n  transition: all 500ms ease;\n}\n.btn-6 span:hover:before {\n  width: 100%;\n}\n.btn-6 span:hover:after {\n  width: 100%;\n}\n\n/* 7 */\n.btn-7 {\n  background: linear-gradient(\n    0deg,\n    rgba(255, 151, 0, 1) 0%,\n    rgba(251, 75, 2, 1) 100%\n  );\n  line-height: 42px;\n  padding: 0;\n  border: none;\n}\n.btn-7 span {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.btn-7:before,\n.btn-7:after {\n  position: absolute;\n  content: \"\";\n  right: 0;\n  bottom: 0;\n  background: rgba(251, 75, 2, 1);\n  box-shadow: -7px -7px 20px 0px rgba(255, 255, 255, 0.9),\n    -4px -4px 5px 0px rgba(255, 255, 255, 0.9),\n    7px 7px 20px 0px rgba(0, 0, 0, 0.2), 4px 4px 5px 0px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n}\n.btn-7:before {\n  height: 0%;\n  width: 2px;\n}\n.btn-7:after {\n  width: 0%;\n  height: 2px;\n}\n.btn-7:hover {\n  color: rgba(251, 75, 2, 1);\n  background: transparent;\n}\n.btn-7:hover:before {\n  height: 100%;\n}\n.btn-7:hover:after {\n  width: 100%;\n}\n.btn-7 span:before,\n.btn-7 span:after {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  top: 0;\n  background: rgba(251, 75, 2, 1);\n  box-shadow: -7px -7px 20px 0px rgba(255, 255, 255, 0.9),\n    -4px -4px 5px 0px rgba(255, 255, 255, 0.9),\n    7px 7px 20px 0px rgba(0, 0, 0, 0.2), 4px 4px 5px 0px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n}\n.btn-7 span:before {\n  width: 2px;\n  height: 0%;\n}\n.btn-7 span:after {\n  height: 2px;\n  width: 0%;\n}\n.btn-7 span:hover:before {\n  height: 100%;\n}\n.btn-7 span:hover:after {\n  width: 100%;\n}\n\n/* 8 */\n.btn-8 {\n  background-color: #f0ecfc;\n  background-image: linear-gradient(315deg, #f0ecfc 0%, #c797eb 74%);\n  line-height: 42px;\n  padding: 0;\n  border: none;\n}\n.btn-8 span {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.btn-8:before,\n.btn-8:after {\n  position: absolute;\n  content: \"\";\n  right: 0;\n  bottom: 0;\n  background: #c797eb;\n  /*box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),\n              -4px -4px 6px 0 rgba(116, 125, 136, .2), \n    inset -4px -4px 6px 0 rgba(255,255,255,.5),\n    inset 4px 4px 6px 0 rgba(116, 125, 136, .3);*/\n  transition: all 0.3s ease;\n}\n.btn-8:before {\n  height: 0%;\n  width: 2px;\n}\n.btn-8:after {\n  width: 0%;\n  height: 2px;\n}\n.btn-8:hover:before {\n  height: 100%;\n}\n.btn-8:hover:after {\n  width: 100%;\n}\n.btn-8:hover {\n  background: transparent;\n}\n.btn-8 span:hover {\n  color: #c797eb;\n}\n.btn-8 span:before,\n.btn-8 span:after {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  top: 0;\n  background: #c797eb;\n  /*box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),\n              -4px -4px 6px 0 rgba(116, 125, 136, .2), \n    inset -4px -4px 6px 0 rgba(255,255,255,.5),\n    inset 4px 4px 6px 0 rgba(116, 125, 136, .3);*/\n  transition: all 0.3s ease;\n}\n.btn-8 span:before {\n  width: 2px;\n  height: 0%;\n}\n.btn-8 span:after {\n  height: 2px;\n  width: 0%;\n}\n.btn-8 span:hover:before {\n  height: 100%;\n}\n.btn-8 span:hover:after {\n  width: 100%;\n}\n\n/* 9 */\n.btn-9 {\n  border: none;\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n.btn-9:after {\n  position: absolute;\n  content: \" \";\n  z-index: -1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #1fd1f9;\n  background-image: linear-gradient(315deg, #1fd1f9 0%, #b621fe 74%);\n  transition: all 0.3s ease;\n}\n.btn-9:hover {\n  background: transparent;\n  box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.5),\n    -4px -4px 6px 0 rgba(116, 125, 136, 0.2),\n    inset -4px -4px 6px 0 rgba(255, 255, 255, 0.5),\n    inset 4px 4px 6px 0 rgba(116, 125, 136, 0.3);\n  color: #fff;\n}\n.btn-9:hover:after {\n  -webkit-transform: scale(2) rotate(180deg);\n  transform: scale(2) rotate(180deg);\n  box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.5),\n    -4px -4px 6px 0 rgba(116, 125, 136, 0.2),\n    inset -4px -4px 6px 0 rgba(255, 255, 255, 0.5),\n    inset 4px 4px 6px 0 rgba(116, 125, 136, 0.3);\n}\n\n/* 10 */\n.btn-10 {\n  background: rgb(22, 9, 240);\n  background: linear-gradient(\n    0deg,\n    rgba(22, 9, 240, 1) 0%,\n    rgba(49, 110, 244, 1) 100%\n  );\n  color: #fff;\n  border: none;\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n.btn-10:after {\n  position: absolute;\n  content: \" \";\n  top: 0;\n  left: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  transition: all 0.3s ease;\n  -webkit-transform: scale(0.1);\n  transform: scale(0.1);\n}\n.btn-10:hover {\n  color: #fff;\n  border: none;\n  background: transparent;\n}\n.btn-10:hover:after {\n  background: rgb(0, 3, 255);\n  background: linear-gradient(\n    0deg,\n    rgba(2, 126, 251, 1) 0%,\n    rgba(0, 3, 255, 1) 100%\n  );\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n\n/* 11 */\n.btn-11 {\n  border: none;\n  background: rgb(251, 33, 117);\n  background: linear-gradient(\n    0deg,\n    rgba(251, 33, 117, 1) 0%,\n    rgba(234, 76, 137, 1) 100%\n  );\n  color: #fff;\n  overflow: hidden;\n}\n.btn-11:hover {\n  text-decoration: none;\n  color: #fff;\n}\n.btn-11:before {\n  position: absolute;\n  content: \"\";\n  display: inline-block;\n  top: -180px;\n  left: 0;\n  width: 30px;\n  height: 100%;\n  background-color: #fff;\n  animation: shiny-btn1 3s ease-in-out infinite;\n}\n.btn-11:hover {\n  opacity: 0.7;\n}\n.btn-11:active {\n  box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.3),\n    -4px -4px 6px 0 rgba(116, 125, 136, 0.2),\n    inset -4px -4px 6px 0 rgba(255, 255, 255, 0.2),\n    inset 4px 4px 6px 0 rgba(0, 0, 0, 0.2);\n}\n\n@-webkit-keyframes shiny-btn1 {\n  0% {\n    -webkit-transform: scale(0) rotate(45deg);\n    opacity: 0;\n  }\n  80% {\n    -webkit-transform: scale(0) rotate(45deg);\n    opacity: 0.5;\n  }\n  81% {\n    -webkit-transform: scale(4) rotate(45deg);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(50) rotate(45deg);\n    opacity: 0;\n  }\n}\n\n/* 12 */\n.btn-12 {\n  position: relative;\n  right: 20px;\n  bottom: 20px;\n  border: none;\n  box-shadow: none;\n  width: 130px;\n  height: 40px;\n  line-height: 42px;\n  -webkit-perspective: 230px;\n  perspective: 230px;\n}\n.btn-12 span {\n  background: rgb(0, 172, 238);\n  background: linear-gradient(\n    0deg,\n    rgba(0, 172, 238, 1) 0%,\n    rgba(2, 126, 251, 1) 100%\n  );\n  display: block;\n  position: absolute;\n  width: 130px;\n  height: 40px;\n  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),\n    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n  margin: 0;\n  text-align: center;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.btn-12 span:nth-child(1) {\n  box-shadow: -7px -7px 20px 0px #fff9, -4px -4px 5px 0px #fff9,\n    7px 7px 20px 0px #0002, 4px 4px 5px 0px #0001;\n  -webkit-transform: rotateX(90deg);\n  -moz-transform: rotateX(90deg);\n  transform: rotateX(90deg);\n  -webkit-transform-origin: 50% 50% -20px;\n  -moz-transform-origin: 50% 50% -20px;\n  transform-origin: 50% 50% -20px;\n}\n.btn-12 span:nth-child(2) {\n  -webkit-transform: rotateX(0deg);\n  -moz-transform: rotateX(0deg);\n  transform: rotateX(0deg);\n  -webkit-transform-origin: 50% 50% -20px;\n  -moz-transform-origin: 50% 50% -20px;\n  transform-origin: 50% 50% -20px;\n}\n.btn-12:hover span:nth-child(1) {\n  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),\n    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);\n  -webkit-transform: rotateX(0deg);\n  -moz-transform: rotateX(0deg);\n  transform: rotateX(0deg);\n}\n.btn-12:hover span:nth-child(2) {\n  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),\n    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);\n  color: transparent;\n  -webkit-transform: rotateX(-90deg);\n  -moz-transform: rotateX(-90deg);\n  transform: rotateX(-90deg);\n}\n\n/* 13 */\n.btn-13 {\n  background-color: #89d8d3;\n  background-image: linear-gradient(315deg, #89d8d3 0%, #03c8a8 74%);\n  border: none;\n  z-index: 1;\n}\n.btn-13:after {\n  position: absolute;\n  content: \"\";\n  width: 100%;\n  height: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n  border-radius: 5px;\n  background-color: #4dccc6;\n  background-image: linear-gradient(315deg, #4dccc6 0%, #96e4df 74%);\n  box-shadow: -7px -7px 20px 0px #fff9, -4px -4px 5px 0px #fff9,\n    7px 7px 20px 0px #0002, 4px 4px 5px 0px #0001;\n  transition: all 0.3s ease;\n}\n.btn-13:hover {\n  color: #fff;\n}\n.btn-13:hover:after {\n  top: 0;\n  height: 100%;\n}\n.btn-13:active {\n  top: 2px;\n}\n\n/* 14 */\n.btn-14 {\n  background: rgb(255, 151, 0);\n  border: none;\n  z-index: 1;\n}\n\n.btn-14:hover {\n  color: #000;\n}\n.btn-14:hover:after {\n  top: auto;\n  bottom: 0;\n  height: 100%;\n}\n.btn-14:active {\n  top: 2px;\n}\n\n/* 15 */\n.btn-15 {\n  background: #b621fe;\n  border: none;\n  z-index: 1;\n}\n.btn-15:after {\n  position: absolute;\n  content: \"\";\n  width: 0;\n  height: 100%;\n  top: 0;\n  right: 0;\n  z-index: -1;\n  background-color: #663dff;\n  border-radius: 5px;\n  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),\n    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n.btn-15:hover {\n  color: #fff;\n}\n.btn-15:hover:after {\n  left: 0;\n  width: 100%;\n}\n.btn-15:active {\n  top: 2px;\n}\n\n/* 16 */\n.btn-16 {\n  border: none;\n  color: #000;\n}\n.btn-16:after {\n  position: absolute;\n  content: \"\";\n  width: 0;\n  height: 100%;\n  top: 0;\n  left: 0;\n  direction: rtl;\n  z-index: -1;\n  box-shadow: -7px -7px 20px 0px #fff9, -4px -4px 5px 0px #fff9,\n    7px 7px 20px 0px #0002, 4px 4px 5px 0px #0001;\n  transition: all 0.3s ease;\n}\n.btn-16:hover {\n  color: #000;\n}\n.btn-16:hover:after {\n  left: auto;\n  right: 0;\n  width: 100%;\n}\n.btn-16:active {\n  top: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
